import { z } from 'zod';
import { Paginated } from './common/pagination.js';
import { StorageObjectKey } from './storage.js';
import { CursorQuery } from './common/pagination.js';
import { CategoryKey } from './taxonomy.js';
export const ProfilePhotoQuery = CursorQuery.extend({
    category1: CategoryKey.optional(),
    source: z.enum(['upload', 'post', 'trip', 'group']).optional(),
});
export const ProfilePhotoView = z.object({
    id: z.string(),
    url: z.string().url(),
    source: z.enum(['upload', 'post', 'trip', 'group']),
    tripId: z.string().optional(),
    category1: CategoryKey.optional(),
    postId: z.string().optional(),
    caption: z.string(),
    createdAt: z.coerce.date(),
    canDelete: z.boolean(),
    canSetAvatar: z.boolean(),
});
export const ProfilePhotoPage = Paginated(ProfilePhotoView);
export const AddProfilePhotoInput = z.object({
    key: StorageObjectKey,
    caption: z.string().trim().max(1000).default(''),
});
//# sourceMappingURL=profile-photos.js.map